import { render } from "./CertificatesList.vue?vue&type=template&id=6a458a3a&scoped=true"
import script from "./CertificatesList.vue?vue&type=script&lang=js"
export * from "./CertificatesList.vue?vue&type=script&lang=js"

import "./CertificatesList.vue?vue&type=style&index=0&id=6a458a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a458a3a"]])

export default __exports__